var _circle;
import * as React from "react";
const SvgPipeline = props => _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 14,
  r: 3
}));
export default SvgPipeline;